import { APIClient } from "../api_helper";
import {
  MasterStudy_API,
} from "../url_helper";
import { GetUserData } from "../../common/service/CommonService";
import { StudyFilterFormValues } from "modules/Study/Study/components/StudyFilter";
import { StudyFormValues } from "modules/Study/Study/helpers/study.types";

/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface CurrentUser {
  userid: number;
}
/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();


export const studyApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    isdraft: boolean | null | undefined,
    searchText?: string | null,
    filters?: StudyFilterFormValues | null,
    pageNumber: number = 1,
    pageSize: number = 10,
    studystatus?: string | null
  ) => {
    const payload = {
      searchtext: searchText || "",
      status: "A",
      studytitle: filters?.studytitle || "",
      sponsorname: filters?.sponsorname || "",
      studycode: filters?.studycode || "",
      studydesign: filters?.studydesign || null,
      totalsubjects: filters?.totalsubjects || null,
      numberofperiods: filters?.numberofperiods || null,
      studystatus: studystatus || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(MasterStudy_API.Study_API + "SelectAll", payload);
  },
  // SELECT METHOD
  getSelectData: (id: number | undefined | null) => {
    const payload = {
      studyid: id,
      config_db: "STD"
    };

    return api.create(MasterStudy_API.Study_API + "Select", payload);
  },
  // INSERT METHOD
  insertData: (payload_data: StudyFormValues) => {
    const user = GetUserData() as CurrentUser;
    // 1. Build periods array dynamically
    const periods = [];

    if (payload_data.numberofperiods) {
      for (let i = 1; i <= payload_data.numberofperiods; i++) {
        const startKey = `period${i}startdate`;
        const checkinKey = `period${i}checkindate`;
        const checkoutKey = `period${i}checkoutdate`;
        const checkintimeKey = `period${i}checkintime`;
        const checkouttimeKey = `period${i}checkouttime`;

        const start = payload_data[startKey];
        const checkin = payload_data[checkinKey];
        const checkout = payload_data[checkoutKey];
        const checkintime = payload_data[checkintimeKey];
        const checkouttime = payload_data[checkouttimeKey];

        if (start && checkin && checkout) {
          periods.push({
            period_no: i,
            start_date: start || null,
            checkin_date: checkin || null,
            checkout_date: checkout || null,
            checkin_time: checkintime || null,
            checkout_time: checkouttime || null,
          });
        }
      }
    }
    const payload = {
      ...payload_data,
      periods: periods,
      isdraft: true,
      studystatus: "Draft",
      createdby: user.userid,
    };
    return api.create(MasterStudy_API.Study_API + "Insert", payload);
  },

  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const studyIdNum = Number(payload_data.studyid);

    const isCompleteTransition = payload_data.isdraft === "completed";
    const isArchiveTransition = payload_data.isdraft === "archive";

    const payload: any = {
      ...payload_data,
      studyid: studyIdNum,
      isdraft: (isCompleteTransition || isArchiveTransition) ? false : payload_data.isdraft,
      studystatus: isCompleteTransition ? "Completed" : isArchiveTransition ? "Archived" : payload_data.studystatus,
      updatedby: user?.userid,
      updatereason: payload_data.updatereason || (isCompleteTransition ? "Study marked as completed via electronic signature verification" : isArchiveTransition ? "Study archived via electronic signature verification" : "Study details updated"),
    };

    // If it's a general update (not completed/archive transition), map sampling points
    if (!isCompleteTransition && !isArchiveTransition) {
      if (
        Array.isArray(payload_data.samplingpoints) &&
        payload_data.samplingpoints.length > 0
      ) {
        payload.samplingpoints = payload_data.samplingpoints
          .map(String)
          .filter(
            (item: string, index: number, arr: string[]) =>
              item && arr.indexOf(item) === index
          );
      }
    }

    return api.create(MasterStudy_API.Study_API + "Update", payload);
  },
  // DELETE METHOD
  deleteData: (payload_data: { id: number; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      studyid: payload_data.id,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
      config_db: "STD",
    };
    return api.create(MasterStudy_API.Study_API + "Delete", payload);
  },
};



